import { render, staticRenderFns } from "./web-set.vue?vue&type=template&id=00ab8c4f&scoped=true&"
import script from "./web-set.vue?vue&type=script&lang=js&"
export * from "./web-set.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ab8c4f",
  null
  
)

export default component.exports